import React, { useEffect, useState } from 'react'
import makeStyles from "@mui/styles/makeStyles"
import { Box, Stack, Paper, Grid, Typography, styled, IconButton, Tooltip, LinearProgress } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { Container } from '@mui/material'
import CommandItem from "../components/CommandItem"
import AlarMobileItem from '../components/AlarmMobileItem'
import VolumeUpIcon from '@mui/icons-material/VolumeUp'
import RefreshIcon from '@mui/icons-material/Refresh'

const useStyles = makeStyles((theme) => {
    return {
        pageEvent: {
            marginBottom: "35px"
        },
        pageEventGrid: {
            width: "calc(100% + 48px) !important"
        },
        stack: {
            maxWidth: "100%"
        },
        alarmPageHeader: {
            height: "100%",
            alignItems: 'center',
            [theme.breakpoints.up('sm')]: {
                display: 'grid',
                gridTemplateColumns: 'repeat(6, 1fr)',
                gap: 1,
                gridTemplateRows: 'auto',
                gridTemplateAreas: `"alarmPageItem1 alarmPageItem2 alarmPageItem3 alarmPageItem4 alarmPageItem5 alarmPageItem6"`,
            },
            [theme.breakpoints.down('sm')]: {
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: 1,
                gridTemplateRows: 'auto',
                gridTemplateAreas: `"alarmPageItem1 alarmPageItem2 alarmPageItem3 alarmPageItem3" 
                "alarmPageItem4 alarmPageItem5 alarmPageItem6 alarmPageItem6"`,
            }
        },
        alarmPageItem1: {
            gridArea: "alarmPageItem1",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        alarmPageItem2: {
            gridArea: "alarmPageItem2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        alarmPageItem3: {
            gridArea: "alarmPageItem3",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        alarmPageItem4: {
            gridArea: "alarmPageItem4",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        alarmPageItem5: {
            gridArea: "alarmPageItem5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        alarmPageItem6: {
            gridArea: "alarmPageItem6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }
});

const AlarmDesktoContainer = styled(Container)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        display: 'none'
    },
    [theme.breakpoints.down('xl')]: {
        "max-width": "1090px"
    },
    [theme.breakpoints.down('lg')]: {
        "max-width": "820px"
    },
    [theme.breakpoints.down('md')]: {
        "max-width": "660px"
    },
}))

const AlarmMobileContainer = styled(Container)(({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
        display: 'none'
    }
}))

const Item = styled(Paper)(({ theme, alarmcolor }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1.5),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    marginTop: 6,
    width: '100%',
    borderRadius: '20px',
    border: '3px solid #E0E0E0',
    borderLeft: '3px solid #7F8C8D',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
        transform: 'translateY(-3px)',
        borderLeft: `3px solid ${alarmcolor || '#3498DB'}`,
        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)'
    }
}));

const ItemHeader = styled(Paper)(({ theme }) => ({
    backgroundColor: '#2C3E50',
    ...theme.typography.body2,
    padding: theme.spacing(1.5),
    textAlign: 'center',
    color: '#ECF0F1',
    height: '56px',
    width: '100%',
    borderRadius: '20px 20px 0 0',
    borderBottom: '3px solid #3498DB',
    fontWeight: 600,
    background: 'linear-gradient(135deg, #2C3E50 0%, #34495E 100%)'
}));

export default function Alarms(props) {
    const history = useHistory()
    const classes = useStyles(props)
    const [commands, setCommands] = useState([])
    const [isLoading, setIsLoading] = useState(false);

    const getAlarmColor = (command) => {
        if (command.dS_DESCRICAO_ALARME === "DESL") {
            return "#00B33C"
        }
        if (command.dS_DESCRICAO_ALARME === "PANI") {
            return "#F58634"
        }
        if (command.dS_DESCRICAO_ALARME === "SILE") {
            return "#FFEA00"
        }
        if (command.dS_DESCRICAO_ALARME === "LIGA") {
            return "#CA373C"
        }
        return "#7F8C8D"
    }

    const populateData = () => {
        setIsLoading(true);

        fetch(`${process.env.REACT_APP_URL}/command/all`, {
            method: 'POST',
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + props.token
            },
            body: JSON.stringify({
                "serialNumber": props.systemData.serialKeys,
            })
        })
        .then(res => res.json())
        .then(data => { 
            setCommands(data);
            setIsLoading(false);
        })
        .catch(err => {
            console.error("Erro ao buscar alarmes:", err);
            setIsLoading(false);
        });
    }

    useEffect(() => {
        populateData()
    }, []);

    return (
        <div style={{opacity: 1, backgroundColor: 'transparent', paddingTop: '1.5rem', paddingBottom: '2rem'}}>
            {isLoading && 
                <LinearProgress color="secondary" style={{position: "fixed", top: "0", left: "0", width: "100%", zIndex: "1201"}} /> 
            }

            <AlarmDesktoContainer className={classes.pageEvent}>
                <Box sx={{ 
                    bgcolor: 'transparent',
                    borderBottom: '1px solid rgba(224, 224, 224, 0.3)',
                    borderRadius: '0',
                    padding: '8px 0',
                    marginBottom: '1rem',
                    boxShadow: 'none',
                    textAlign: 'center',
                    cursor: 'default',
                    pointerEvents: 'none',
                    userSelect: 'none'
                }}>
                    <Typography 
                        variant="h5" 
                        component="h3" 
                        sx={{ 
                            fontWeight: 400,
                            color: 'text.secondary',
                            letterSpacing: '0.5px',
                            textTransform: 'uppercase',
                            fontSize: '0.95rem'
                        }}
                    >
                        Comandos de Alarmes - Hoje ({new Date().toLocaleDateString()})
                    </Typography>
                </Box>

                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    mb: 3,
                    flexWrap: 'wrap',
                    gap: 2
                }}>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Tooltip title="Recarregar Alarmes">
                            <IconButton 
                                onClick={() => populateData()}
                                disabled={isLoading}
                                sx={{
                                    bgcolor: 'rgba(52, 152, 219, 0.2)',
                                    border: '2px solid #3498DB',
                                    '&:hover': { bgcolor: 'rgba(52, 152, 219, 0.4)' }
                                }}
                            >
                                <RefreshIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>

                    <Box sx={{ 
                        bgcolor: 'rgba(255, 255, 255, 0.05)',
                        border: '3px solid #E0E0E0',
                        borderRadius: '20px',
                        padding: '12px 24px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                        marginLeft: 'auto'
                    }}>
                        <Typography variant="h6" color="textPrimary">
                            Alarmes Encontrados: <strong>{commands.length}</strong>
                        </Typography>
                    </Box>
                </Box>

                <Stack className={classes.stack} alignItems="center" spacing={2} marginTop={1}>
                        <ItemHeader key={0} xs={12} md={6} lg={4}>
                            <Box className={classes.alarmPageHeader}>
                                <Box className={classes.alarmPageItem1}><VolumeUpIcon /></Box>
                                <Box className={classes.alarmPageItem2}> <Typography variant="delta">Central</Typography></Box>
                                <Box className={classes.alarmPageItem3}><Typography variant="delta">Descrição</Typography></Box>
                                <Box className={classes.alarmPageItem4}><Typography variant="delta">Local</Typography></Box>
                                <Box className={classes.alarmPageItem5}><Typography variant="delta">Origem</Typography></Box>
                                <Box className={classes.alarmPageItem6}><Typography variant="delta">Data</Typography></Box>
                            </Box>
                        </ItemHeader>
                        {commands.length > 0
                        ?
                        <>
                        {commands.slice(0).reverse().map(command => (
                            <Item key={command.id} xs={12} md={6} lg={4} alarmcolor={getAlarmColor(command)}>
                                <CommandItem commandData={command} />
                            </Item>
                        ))}
                        </>
                        :
                        <>
                            <Box key={1} xs={12} md={6} lg={4}>
                                <center>
                                    <h4>Sem Alarmes Registrados na Data de Hoje!</h4>
                                </center>
                            </Box>
                        </>
                        }
                    </Stack>
            </AlarmDesktoContainer>

            <AlarmMobileContainer className={classes.pageEvent}>
                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'flex-start',
                    mb: 2
                }}>
                    <Tooltip title="Recarregar Alarmes">
                        <IconButton 
                            onClick={() => populateData()}
                            sx={{
                                bgcolor: 'rgba(52, 152, 219, 0.2)',
                                border: '2px solid #3498DB',
                                '&:hover': { bgcolor: 'rgba(52, 152, 219, 0.4)' }
                            }}
                        >
                            <RefreshIcon />
                        </IconButton>
                    </Tooltip>
                </Box>

                <Grid alignItems="center" container spacing={3} className={classes.pageEventGrid}>
                    {commands.length > 0
                    ?
                    <>
                    {commands.slice(0).reverse().map(command => (
                        <Grid item key={command.id} xs={12} md={12} lg={12}>
                            <AlarMobileItem key={command.id} commandData={command} />
                        </Grid>
                    ))}
                    </>
                    :
                        <>
                        <Grid key={1} xs={12} md={12} lg={12}>
                            <center>
                                <h4>Sem Alarmes Registrados na Data de Hoje!</h4>
                            </center>
                        </Grid>
                    </>
                    }
                </Grid>
            </AlarmMobileContainer>
        </div>
    );
}